<template>
  <section>
    <LoadingSpinner v-if="loading" />
    <div v-else class="mx-2">
      <div class="col-md-12 w-100 my-2 card p-2">
        <!-- Table (list orders) + -->
        <div class="mx-0 px-0 table-responsive">
          <Table v-if="!loading && !showEmptyImage" class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="orders"
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="captainkey"
            @goToAgency="goToAgency"
            @editOrder="editOrder"
            @openTarget="openTarget"
            @openClient="openClient">
          </Table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { adminService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
  },

  data() {
    return {
      filters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      orders: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "task_open_hours",
            type: 'time',
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "stats",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.nonverified"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.verified"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "0",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.unverified"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value_emit: "id",
            value: "target_status_id",
            // class: "text-primary",
            type: "emit",
            emit: "editOrder",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "client_status",
            class: "text-primary",
          },
        ],
        [
          {
            value: "sale",
          },
        ],
      ],
      headers: [
        {
          label: 'Time',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.creation"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.name"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.status"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
          id:3,
        },
        {
          label: this.$t("lang.column.client") + ' ' + this.$t("lang.column.status"),
          class: "overflowhide",
          id:2,
        },
        {
          label: 'Sales',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },

  mounted() {
    this.loadOrders();
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
  },

  props: {
    client_id: {
      type: Number,
      default: undefined,
    },
    fromClient: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    loadOrders(order, filter = []) {
      adminService.getTargetSalesWithoutProspectors('17').then((response) => {
        if (response !== undefined) {
          this.orders = response.result;
          this.loading = false;
        }
      });
    },
    editOrder(index) {
      this.$router.push("/orders/" + index);
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },

    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    goToAgency(client_id, client_name) {
      //(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);
      if(!this.hasPermissions('isAgencyManager') || this.hasPermissions('adminAgency')){
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
